import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getFxtEdition } from "@/js/pages/product/rackbuilder/utils/fxt-utils"
import { getCommonAccessorySelections, getFrontSelection, getDepthSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

// Config for FM-6 / FML-6 addon variants — other addon types have their own config files
export function createStandardAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const isHalfRack = rack?.attributes?.rack_size === '4'
  const edition = rack?.attributes?.edition?.toString() ?? ''

  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back             : 'nameplate',
    front            : getFrontSelection(rogue, buyRequest, meta) || 'skinny',
    edition          : getFxtEdition(edition),
    color            : RACK_COLORS['Rogue Red'],
    jcup             : '',
    depth            : getDepthSelection(rack, meta),
    sixPost          : !isHalfRack,
    storagePosts     : false,
    ghostRack        : false,
    ftShrouds        : rack?.attributes.rig_or_wm !== 'No',
    spotterArms      : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer  : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    rhinoRackTrainer : functionalTrainer?.attributes.rig_type === 'Rhino Rack Trainer',
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    isAddon          : true,
  }
}
